import styled from '@emotion/styled';
import { H3, Text, TextLabel, SmallText } from 'ds/components/typography';
import { Link } from 'components/link';
import { colorToAlpha } from 'helpers/insight';

export const Root = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const Header = styled(H3)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const Body = styled.div<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  border: `1px solid ${theme.colors.neutrals.grey6}`,
  backgroundColor: theme.colors.neutrals.white,
  padding: isMobile ? theme.spacing(3, 2) : theme.spacing(4, 3),
  borderRadius: theme.borderRadius.small,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const AgentLogoWrapper = styled.div(({ theme }) => ({
  border: `1px solid ${theme.colors.neutrals.grey8}`,
  overflow: 'hidden',
  borderRadius: theme.borderRadius.round,
  height: '80px',
  width: '80px',
  'img': {
    display: 'block',
    height: '80px',
    width: '80px',
  },
}));

export const OfficeLogoWrapper = styled.div<{ image: string }>(({ theme, image }) => ({
  width: '80px',
  height: '80px',
  overflow: 'hidden',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  backgroundPosition: 'center center',
  backgroundColor: theme.colors.neutrals.white,
  backgroundImage: `url(${image})`,
  border: `1px solid ${theme.colors.neutrals.grey8}`,
}));

export const AgentLeadingLabel = styled(TextLabel)(({ theme }) => ({
  position: 'absolute',
  zIndex: 2,
  bottom: '-8px',
  color: theme.colors.brand.lighter,
  backgroundColor: theme.colors.brand.lightest,
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.borderRadius.tiny,
  border: `1px solid ${colorToAlpha(theme.colors.brand.lighter, 0.2)}`,
  whiteSpace: 'nowrap',
  left: '50%',
  transform: 'translateX(-50%)',
}));

export const AgentName = styled(Text)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  color: theme.colors.neutrals.grey1,
}));

export const OfficeName = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const AgentHint = styled(SmallText)<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  color: isMobile ? theme.colors.neutrals.grey3 : theme.colors.neutrals.grey1,
}));

export const DeveloperInfo = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const DescriptionWrapper = styled(Text)<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  color: theme.colors.neutrals.grey1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: isMobile ? 3 : 2,
  WebkitBoxOrient: 'vertical',
}));

export const DeveloperLinkText = styled(Text)({
  display: 'flex',
  alignItems: 'center',
});

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.colors.brand.main,
  textDecoration: 'none',
  fontWeight: 500,
}));
